import { Scale } from "lucide-react";
import { Link } from "react-router";
import { SEO } from "./SEO";

export function TermsConditions() {
    return (
        <div className="max-w-4xl mx-auto px-6 py-12">
            <SEO
                title="Terms & Conditions | Solace SMART Solutions"
                description="Read the terms and conditions for using Solace SMART Solutions' website and services."
            />
            <Link to="/" className="text-[#E9A319] hover:underline mb-8 inline-block text-sm font-semibold">&larr; Back to Home</Link>
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8 md:p-12">
                <div className="flex items-center gap-4 mb-8 pb-8 border-b border-gray-100">
                    <div className="w-14 h-14 bg-blue-50 text-[#1a2d50] rounded-xl flex items-center justify-center shrink-0">
                        <Scale className="w-7 h-7" />
                    </div>
                    <div>
                        <h1 className="text-3xl md:text-4xl text-[#1a2d50]" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif", fontWeight: 800 }}>Terms & Conditions</h1>
                        <p className="text-muted-foreground mt-1">Effective Date: October 2023</p>
                    </div>
                </div>

                <div className="space-y-8 text-gray-700" style={{ lineHeight: 1.8 }}>
                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>1. Agreement to Terms</h2>
                        <p>These Terms of Use constitute a legally binding agreement made between you, whether personally or on behalf of an entity ("you") and Solace SMART Solutions ("Company," "we," "us," or "our"), concerning your access to and use of the website as well as any other media form, media channel, mobile website or mobile application related, linked, or otherwise connected thereto (collectively, the "Site").</p>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>2. Intellectual Property Rights</h2>
                        <p>Unless otherwise indicated, the Site is our proprietary property and all source code, databases, functionality, software, website designs, audio, video, text, photographs, and graphics on the Site (collectively, the "Content") and the trademarks, service marks, and logos contained therein (the "Marks") are owned or controlled by us or licensed to us, and are protected by copyright and trademark laws.</p>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>3. User Representations</h2>
                        <p>By using the Site, you represent and warrant that:</p>
                        <ul className="list-disc pl-5 mt-2 space-y-1">
                            <li>All registration information you submit will be true, accurate, current, and complete.</li>
                            <li>You will maintain the accuracy of such information and promptly update such registration information as necessary.</li>
                            <li>You have the legal capacity and you agree to comply with these Terms of Use.</li>
                            <li>You will not access the Site through automated or non-human means, whether through a bot, script, or otherwise.</li>
                        </ul>
                    </section>

                    <section>
                        <h2 className="text-xl text-[#1a2d50] mb-3" style={{ fontWeight: 700 }}>4. Modifications and Interruptions</h2>
                        <p>We reserve the right to change, modify, or remove the contents of the Site at any time or for any reason at our sole discretion without notice. However, we have no obligation to update any information on our Site. We also reserve the right to modify or discontinue all or part of the Site without notice at any time. We will not be liable to you or any third party for any modification, price change, suspension, or discontinuance of the Site.</p>
                    </section>
                </div>
            </div>
        </div>
    );
}
